<template>
  <SmallSquare :padding='true' content="1、小程序订阅消息模板，针对会员推送通知提醒。
  2、启用后的订阅消息模板在关联场景触发授权并允许后系统会发送通知提醒
  3、仅适用于云店" />
  <a-card :bordered='false'>
    <!-- <a-tabs> -->
      <!-- <a-tab-pane key="1" tab="我的模版"> -->
      <my v-if="reload "/>
      <!-- </a-tab-pane> -->
      <!-- <a-tab-pane key="2" tab="模版库">
      <templateLibs v-on:success="success"/>
      </a-tab-pane> -->
        <!-- <a-tab-pane key="3" tab="操作记录">
        <action />
      </a-tab-pane>
        <a-tab-pane key="4" tab="审核记录">
        <review />
      </a-tab-pane> -->
    <!-- </a-tabs> -->
  </a-card>
</template>
<script>
import { ref } from 'vue'
import my from './components/my'
// import review from './components/review'
// import action from './components/action'
// import templateLibs from './components/templateLibs'
export default {
  name:"sub",
  components:{my},
  setup(){
    const reload=ref(true)
    const success=()=>{
        reload.value=false
       var time= setTimeout(()=>{
          reload.value=true
          time=null
        },200)
    }
    return{
      reload,
      success
    }
  }
}
</script>